/**
 * The one package → illustration mapping (website, ios, custom), shared by
 * the landing Offerings section and the Services mega menu so both always
 * show the same art for a package.
 */
import type { ComponentType } from "react";
import type { PackageKey } from "@/lib/brand";
import { WebIllustration } from "./WebIllustration";
import { IosIllustration } from "./IosIllustration";
import { CustomIllustration } from "./CustomIllustration";

export const packageIllustrations: Record<PackageKey, ComponentType> = {
  website: WebIllustration,
  ios: IosIllustration,
  custom: CustomIllustration,
};
